var Intent;
(function(Intent) {
    Intent['CAPTURE'] = 'capture';
    Intent['AUTHORIZE'] = 'authorize';
    Intent['TOKENIZE'] = 'tokenize';
    Intent['SUBSCRIPTION'] = 'subscription';
})(Intent || (Intent = {}));

export { Intent };
//# sourceMappingURL=context.js.map
